import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useEffect, useMemo} from "react";
import ApiService from "../../../core/service/api-service";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import {useRowDetailDrawer} from "../../../core/components/data-grid/useRowDetailDrawer";
import hospitalColumns from "./HospitalColumns";
import {useTranslation} from "react-i18next";
import PacsSystemGrid from "./expanded-row/pacs-systems/PacsSystemGrid";
import {Card, Tabs} from "antd";
import HL7ClientGrid from "./expanded-row/hl7-client/HL7ClientGrid";

export default function HospitalGrid()
{
    const {t} = useTranslation();
    const {setData, setPaginationResult, queryModel, setDataGridProps} = useDataGrid();

    const hospitalCols = useMemo(() => hospitalColumns(t), []);

    const { expandColumn, drawer } = useRowDetailDrawer({
        name: 'hospital',
        columns: hospitalCols,
        getTitle: (record) => record.name || record.id,
        renderDetail: (record) => (
            <Card size={'small'}>
                <Tabs>
                    <Tabs.TabPane key={`pacs-system-${record.id}`} tab={'Pacs Systems'}>
                        <PacsSystemGrid hospitalId={record.id} />
                    </Tabs.TabPane>
                    <Tabs.TabPane key={`hl7-client-${record.id}`} tab={'HL7 Clients'}>
                        <HL7ClientGrid hospitalId={record.id} />
                    </Tabs.TabPane>
                </Tabs>
            </Card>
        ),
    });

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            virtual: true,
            columns: [expandColumn, ...hospitalCols],
        })
    }, [])

    const getHospitalGrid = async () => {
        const response = await ApiService.Hospital.GetDataGrid(queryModel);
        if(response.success)
        {
            setData(response.data);
            setPaginationResult(response.pagination)
        }
    }

    useEffect(() => {
        getHospitalGrid()
    }, [queryModel.updateKey])

    return (
        <>
            <DataGrid name={'hospital'}/>
            {drawer}
        </>
    )
}
